import React from 'react'
import { Link } from 'react-router-dom'

import { Icon } from 'src/components/ui'
import { formattedText } from 'src/utils/formattedText'

import type { UserTransactionType } from '../../HistoryOfTransactions'
import TransactionIcon from '../TransactionIcon/TransactionIcon'
import styles from './TransactionItem.module.scss'

interface Props {
  transactions: UserTransactionType[]
  t: any
}

const TransactionItem: React.FC<Props> = ({ transactions, t }) => {
  const currentDate = new Date()
  const transactionDate = transactions[0].created_at.split('T')[0]
  const isNow = currentDate.toISOString().split('T')[0] === transactionDate

  const date = transactionDate.split('-')
  const formattedDate = isNow ? t('transactions_page.today') : `${date[2]}.${date[1]}.${date[0]}`

  return (
    <div className={styles.item}>
      <p className={styles.item_date}>{formattedDate}</p>

      <ul className={styles.transactions}>
        {[...transactions].reverse().map(({ type, id, amount_stars }) => {
          // const typeResult =
          //   // type === 'TRANSFER' || type === 'INVESTMENT'
          //   //   ? amount_stars < 0
          //   //     ? types[type].less
          //   //     : types[type].more
          //   //   : types[type]

          // const classes = type !== 'LOSE' ? (typeResult === '+' ? 'plus' : 'minus') : 'LOSE'

          return (
            <Link to={`/transactions/${id}`} className={styles.transactions_item} key={id}>
              <div className={styles['transactions_item-type']}>
                <TransactionIcon name={type} />
                <p>{t(`transactions_page.${type}`)}</p>
              </div>

              <div className={`${styles['transactions_item-amount']}`}>
                <p>{formattedText(Number(amount_stars.toFixed(3)))}</p>
                <Icon name='star' />
              </div>
            </Link>
          )
        })}
      </ul>
    </div>
  )
}

export default TransactionItem
